export default __webpack_public_path__ + "static/media/tavi_main_mobile.84368139.jpg";